<template>
    <hts-drawer
        ref="drawer"
        v-model="visible"
        :submit="submit"
        :title="$t('labels.quoteAdd')"
        :size="90"
        :rules="cRules"
        @close="close">
        <div
            v-if="visible"
            :style="{ minWidth: minWidthScroll }">
            <hts-select-quote-request
                v-if="page === 0"
                v-model="dataCreateQuote._id"
                v-model:text="dataCreateQuote.code"
                required
                creatable
                @change="handleChangeQuoteRequest" />
            <div
                v-loading="loadingQuoteRequest"
                class="pt-2">
                <div v-if="page === 0">
                    <hts-card :title="$t('labels.customer')">
                        <div class="grid gap-x-2 grid-cols-4">
                            <hts-select-cooperator
                                v-model="dataCreateQuote.customer"
                                v-model:name="dataCreateQuote.customerName"
                                :label="$t('labels.customer')"
                                type-cooperator="CUSTOMER"
                                :creatable="true"
                                required
                                disabled
                                prop="customer"
                                name-select="customer" />
                            <hts-select-cooperator-contact
                                v-model="dataCreateQuote.contact"
                                v-model:name="dataCreateQuote.contactName"
                                :cooperator-id="dataCreateQuote.customer"
                                :label="$t('labels.contact')"
                                :creatable="true"
                                disabled
                                prop="contact"
                                name-select="contact"
                                @change="selectContact" />
                            <hts-form-input
                                v-model="dataContact.email"
                                :label="$t('labels.email')"
                                disabled />
                            <hts-form-input
                                v-model="dataContact.phone"
                                :label="$t('labels.phone')"
                                disabled />
                        </div>
                    </hts-card>
                    <hts-card :title="$t('labels.shippingInformation')">
                        <div class="grid gap-x-2 grid-cols-2">
                            <hts-select-cooperator-business-opportunity
                                v-model="dataCreateQuote.businessOpportunity"
                                v-model:name="dataCreateQuote.businessOpportunityName"
                                :label="$t('labels.businessOpportunity')"
                                :creatable="true"
                                disabled
                                :cooperator-id="dataCreateQuote.customer"
                                prop="businessOpportunity"
                                name-select="businessOpportunity"
                                key-label="nameCustom1"
                                key-sub-label="nameCustom2"
                                @change="selectCooperatorBusinessOpportunity" />
                            <hts-select-commodity-opportunity
                                v-model="dataCreateQuote.commodity"
                                v-model:name="dataCreateQuote.commodityName"
                                :label="$t('labels.commodity')"
                                :cooperator-id="dataCreateQuote.customer"
                                :opportunity-id="dataCreateQuote.businessOpportunity"
                                disabled
                                prop="commodityBusinessOpportunity"
                                name-select="commodityBusinessOpportunity" />
                        </div>

                        <hts-form-input
                            v-model="dataCreateQuote.workflowName"
                            :label="$t('labels.workflow')"
                            disabled />
                        <ul
                            v-if="dataCreateQuote.positions && dataCreateQuote.positions.length"
                            class="steps steps-vertical w-full">
                            <li
                                v-for="(item, index) in dataCreateQuote.positions"
                                :key="index"
                                data-content=" "
                                class="pl-10 step w-full">
                                <div class="flex items-center justify-center w-full">
                                    <span class="w-52 flex justify-start">
                                        {{ item.nodeTypeName }}
                                    </span>
                                    <div class="flex items-center w-full gap-5">
                                        <hts-form-input
                                            v-model="item.fullNameNode"
                                            class="w-full"
                                            readonly />
                                        <hts-form-button
                                            icon-name="hi-eye-icon"
                                            size="small"
                                            class="w-96"
                                            color="info"
                                            @click="() => openWorkflowPosition(item)">
                                            {{ $t('labels.viewTaskInfo') }}
                                        </hts-form-button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <!--
                          <div class="text-right">
                          <span
                          class="text-lg text-main-600 cursor-pointer italic"
                          @click="openWithMap">
                          {{ $t('labels.openWithMap') }}
                          </span>
                          </div>
                        -->
                        <div>
                            <div v-if="dataCreateQuote.transportation === 'CONTAINER'">
                                <hts-form-input
                                    v-model="dataCreateQuote.contName"
                                    :label="$t('labels.cont')"
                                    required
                                    disabled />
                                <span>
                                    {{ $t('labels.requestSpecial') }}
                                    <span class="text-error-500">
                                        *
                                    </span>
                                </span>
                                <div class="flex">
                                    <hts-form-checkbox
                                        v-if="dataCreateQuote.contCategory === 20"
                                        v-model="dataCreateQuote.mergeContainer"
                                        color="secondary"
                                        disabled
                                        :items="[{ label: $t('labels.mergeContainer'), value: false }]" />
                                    <hts-form-checkbox
                                        v-model="dataCreateQuote.headContainer"
                                        color="secondary"
                                        disabled
                                        :items="[{ label: $t('labels.headContainer'), value: false }]" />
                                </div>
                            </div>
                            <div v-else-if="dataCreateQuote.transportation === 'NON_CONTAINER'">
                                <hts-form-input
                                    v-model="dataCreateQuote.vehicleCategoryName"
                                    :label="$t('labels.vehicleType')"
                                    readonly />
                            </div>
                            <hts-form-input
                                v-model="dataCreateQuote.productivity"
                                :label="$t('labels.productivityByMount')"
                                type="number"
                                readonly
                                prop="productivity"
                                name="productivity">
                                <template #suffix>
                                    <span>
                                        {{ dataCreateQuote.transportation ? (dataCreateQuote.transportation === 'CONTAINER' ? $t('labels.cont') : $t('labels.vehicle')) : '-' }}
                                    </span>
                                </template>
                            </hts-form-input>
                            <hts-form-input
                                v-model="dataCreateQuote.weightCommodity"
                                :label="$t('labels.weightCommodityByKG1')"
                                type="number"
                                readonly
                                prop="weightCommodityByKG"
                                name="weightCommodityByKG1">
                                <template #suffix>
                                    <span>
                                        {{ dataCreateQuote.transportation ? (dataCreateQuote.transportation === 'CONTAINER' ? $t('labels.cont') : $t('labels.vehicle')) : '-' }}
                                    </span>
                                </template>
                            </hts-form-input>
                            <hts-form-textarea
                                v-model="dataCreateQuote.request"
                                :label="$t('labels.requestOther')"
                                readonly />
                        </div>
                    </hts-card>
                    <workflow-position
                        ref="workflowPosition"
                        @update="updatePosition" />
                    <!--
                      <view-position
                      ref="viewPosition"
                      :edit="false" />
                    -->
                </div>
                <div v-if="page === 1">
                    <add-quote
                        ref="addQuote"
                        :quote-request-id="dataCreateQuote._id"
                        :show-request-price="true"
                        :show-modal-alert="true"
                        :quote-data="dataQuotePrice" />
                </div>
            </div>
        </div>
        <template #footer>
            <template v-if="page === 0">
                <div />
                <hts-form-button
                    v-if="checkPermission(layoutPermissions.quote_management)"
                    icon-name="hi-arrow-long-right-icon"
                    icon-position="right"
                    color="primary"
                    type="submit"
                    :loading="loadingViewQuote"
                    @click="typeSubmit = 1">
                    {{ $t('labels.viewPrice') }}
                </hts-form-button>
            </template>
            <template v-else>
                <hts-form-button
                    icon-name="hi-arrow-long-left-icon"
                    color="primary"
                    type="submit"
                    @click="!(addQuote && addQuote.step === 0) ? addQuote && addQuote.previousStep() : (page = 0)">
                    {{ $t('labels.back') }}
                </hts-form-button>
                <hts-form-button
                    v-if="addQuote && addQuote.step < 2"
                    icon-name="hi-arrow-long-right-icon"
                    icon-position="right"
                    color="primary"
                    type="submit"
                    @click="addQuote && addQuote.nextStep()">
                    {{ $t('labels.next') }}
                </hts-form-button>
                <div
                    v-if="addQuote && addQuote.step === 2"
                    class="flex">
                    <hts-form-button
                        type="submit"
                        icon-name="hi-arrow-long-right-icon"
                        icon-position="right"
                        color="primary"
                        :loading="loadingSubmitCreateQuoteSendEmail"
                        :disabled="loadingSubmitCreateQuote || addQuote.checkMarkupPricingSelection({ checkPermission: true })"
                        @click="typeSubmit = 3">
                        {{ $t('labels.createAndSend') }}
                    </hts-form-button>

                    <hts-form-button
                        type="submit"
                        icon-name="hi-arrow-long-right-icon"
                        class="ml-5"
                        icon-position="right"
                        color="primary"
                        :disabled="loadingSubmitCreateQuoteSendEmail"
                        :loading="loadingSubmitCreateQuote"
                        @click="typeSubmit = 2">
                        {{ $t('labels.create') }}
                    </hts-form-button>
                </div>
            </template>
        </template>
    </hts-drawer>
</template>

<script setup lang="ts">
import cloneDeep from 'lodash-es/cloneDeep'
import AddQuote from '../-components/add.vue'
import { IQuoteRequest } from '../quote-request/-components/ignore/imports/form'
import WorkflowPosition from '../quote-request/-components/workflow-position.vue'
// import ViewPosition from '../quote-request/-components/view-position.vue'
import { $api, $lodash } from '#imports'
import { checkPermission } from '@/utils/permission-check'
import layoutPermissions from '~/data/permissions/layout-permissions'
import { IWorkflowPosition } from '~/pages/admincp/workflow/ignore/imports/form'

import screen from '~/components/utils/screen'

const breakpoint = screen()
const minWidthScroll = computed(() => {
  return `${breakpoint.value.thresholds.sm + 100}px`
})

const { $disableReactive } = useNuxtApp()

const visible = ref(false)

const createQuoRequest = ref(false)

const page = ref(0)

const typeSubmit = ref(0)
const submit = () => {
  switch (
    typeSubmit.value // 1 get price 2 create quote 3 create quote and send mail
  ) {
  case 0:
    break
  case 1:
    return getQuotePriceData()
  case 2:
    return handleSubmitCreateQuote()
  case 3:
    return handleSubmitCreateQuoteSendEmail({ sendEmail: true })
  default:
  }
}

const addQuote = ref()
const close = () => {
  visible.value = false
}

const emits = defineEmits(['refreshTables'])

const workflowPosition = ref()
const openWorkflowPosition = (position: IWorkflowPosition) => {
  if (workflowPosition.value) {
    workflowPosition.value.open($disableReactive(position), $disableReactive(dataCreateQuote.value), true)
  }
}

const open = () => {
  visible.value = true
}

const resetField = () => {
  dataContact.value = {}
  dataCreateQuote.value = {
    customer: '',
    customerName: '',
    commodity: '',
    commodityName: '',
    contact: '',
    businessOpportunity: '',
    workflow: '',
    workflowData: [],
    productivity: null,
    weightCommodity: null,
    tasks: [
      {
        code: '',
        value: null
      }
    ],
    request: '',
    requestSpecial: '',
    contactName: '',
    mergeContainer: false,
    headContainer: false,
    transportation: '',
    businessOpportunityName: '',
    contCategory: null,
    vehicleCategory: '',
    status: 0
  }
}

defineExpose({
  open
})
const store = $store()

const defaultItems = {
  _id: '',
  code: '',
  customer: '',
  customerName: '',
  commodity: '',
  commodityName: '',
  contact: '',
  positions: [],
  businessOpportunity: '',
  businessOpportunityName: '',
  workflow: '',
  workflowName: '',
  workflowData: [],
  productivity: null,
  weightCommodity: null,
  tasks: [
    {
      code: '',
      value: null
    }
  ],
  request: '',
  requestSpecial: '',
  transportation: '',
  contactName: '',
  mergeContainer: false,
  headContainer: false,
  contCategory: null,
  contName: '',
  vehicleCategoryName: '',
  vehicleCategory: '',
  status: 0
}
const dataCreateQuote = ref<IQuoteRequest>($lodash.cloneDeep(defaultItems))

const props = defineProps({
  initialValues: {
    type: Object,
    default: () => {}
  }
})

const dataContact = ref<{ [key: string]: any }>({})
const selectContact = (item: { [key: string]: any }) => {
  dataContact.value = Array.isArray(item) && item.length && item[0]
}

const dataCooperatorBusinessOpportunity = ref<{ [key: string]: any }>({})
const selectCooperatorBusinessOpportunity = async (item: { [key: string]: any }) => {
  dataCooperatorBusinessOpportunity.value = Array.isArray(item) && item.length && item[0]
  await setFormData()
}

const setFormData = async () => {
  dataCreateQuote.value.productivity = dataCooperatorBusinessOpportunity.value.productivity || null
  dataCreateQuote.value.weightCommodity = dataCooperatorBusinessOpportunity.value.weightCommodity || null
  dataCreateQuote.value.transportation = dataCooperatorBusinessOpportunity.value.transportation || ''
  if (dataCreateQuote.value.transportation && dataCreateQuote.value.transportation === 'CONTAINER') {
    dataCreateQuote.value.contName = listLabelCont[dataCooperatorBusinessOpportunity.value.contCategory] ?? ''
  } else if (dataCreateQuote.value.transportation && dataCreateQuote.value.transportation === 'NON_CONTAINER') {
    dataCreateQuote.value.vehicleCategoryName = dataCooperatorBusinessOpportunity.value.vehicleCategoryDetail?.name ?? ''
  }
  dataCreateQuote.value.workflow = dataCooperatorBusinessOpportunity.value.workflow
  dataCreateQuote.value.workflowName = dataCooperatorBusinessOpportunity.value.workflowName
  dataCreateQuote.value.contCategory = dataCooperatorBusinessOpportunity.value.contCategory
  dataCreateQuote.value.vehicleCategory = dataCooperatorBusinessOpportunity.value.vehicleCategory
  dataCreateQuote.value.headContainer = false
  dataCreateQuote.value.mergeContainer = false
  dataCreateQuote.value.positions = dataCooperatorBusinessOpportunity.value.positions || []
  await setDataPosition()
}

const setDataPosition = async () => {
  try {
    const api = $url.quote.quoteRequest.viewTimeComplete
    if (dataCreateQuote.value.businessOpportunity) {
      const data: any = await $api(api, { uriParams: { IDBUSINESSOPPORTUNITY: dataCreateQuote.value.businessOpportunity } })
      const resData = data?.data?.value
      if (resData && resData.success) {
        dataCreateQuote.value.positions = resData.data
      }
    }
  } catch (e) {}
}

const listLabelCont: { [key: number]: any } = {
  10: $t('labels.vehicleModule.10ft'),
  20: $t('labels.vehicleModule.20ft'),
  40: $t('labels.vehicleModule.40ft'),
  45: $t('labels.vehicleModule.45ft'),
  50: $t('labels.vehicleModule.other')
}

const configCont: { [key: string]: any } = computed(() => store.globalSettings.getGlobalSettings.configCont)
const configVehicle: { [key: string]: any } = computed(() => {
  return store.data.getVehicleCategories
})

const dataRule = computed(() => {
  const result: { [key: string]: any } = {}
  if (dataCreateQuote.value.transportation === 'CONTAINER' && dataCreateQuote.value.contCategory) {
    if (configCont.value && configCont.value[dataCreateQuote.value.contCategory] && configCont.value[dataCreateQuote.value.contCategory].weightCargo) {
      result.weightCommodityByKG = `required|validationCustom:
      ${dataCreateQuote.value.weightCommodity && dataCreateQuote.value.weightCommodity <= configCont.value[dataCreateQuote.value.contCategory].weightCargo}--
      ${$t('labels.checkWeightContainer')} - ${configCont.value[dataCreateQuote.value.contCategory].weightCargo}`
    }
  } else if (dataCreateQuote.value.transportation === 'NON_CONTAINER' && dataCreateQuote.value.vehicleCategory && configVehicle.value) {
    const findVehicleCategory = configVehicle.value.find((findVehicleCategory: { [key: string]: any }) => {
      return findVehicleCategory._id === dataCreateQuote.value.vehicleCategory
    })
    if (findVehicleCategory) {
      const min = Number(findVehicleCategory.from || 0)
      const max = Number(findVehicleCategory.to || 999999999999999)
      result.weightCommodityByKG = `required|validationCustom:
      ${dataCreateQuote.value.weightCommodity && min <= dataCreateQuote.value.weightCommodity && dataCreateQuote.value.weightCommodity < max}--
      ${$t('labels.checkWeightVehicle')} (${min} <= ${$t('labels.weightCommodity')} < ${max})`
    }
  }
  return result
})

// const viewPosition = ref()

// const openWithMap = () => {
//   viewPosition.value && viewPosition.value.open(
//     {
//       positions: dataCreateQuote.value.positions,
//       routingPositionsData: dataCreateQuote.value.routingPositions,
//       routingConnectionsData: dataCreateQuote.value.routingConnections || [],
//       routingPositionsConnections: dataCreateQuote.value.routingPositionsConnections
//     })
// }

const updatePosition = (data: { [key: string]: any }) => {
  if (data && typeof data === 'object' && dataCreateQuote.value.positions) {
    const findIndexPosition = dataCreateQuote.value.positions.findIndex((item: { [key: string]: any }) => {
      return item.index === data.index
    })
    if (findIndexPosition !== -1 && dataCreateQuote.value.positions) {
      dataCreateQuote.value.positions[findIndexPosition] = data
    }
  }
}

const dataQuotePrice = ref({})
const loadingViewQuote = ref(false)
const getQuotePriceData = async () => {
  try {
    loadingViewQuote.value = true
    const api = $url.quote.getQuotePrice
    if (dataCreateQuote.value.businessOpportunity) {
      const data: any = await $api(api, { uriParams: { quoteRequestId: dataCreateQuote.value._id } })
      const resData = data?.data?.value
      if (resData && resData.success) {
        dataQuotePrice.value = resData.data
        page.value = 1
      }
      loadingViewQuote.value = false
    }
  } catch (e) {
    loadingViewQuote.value = false
  }
}

const loadingQuoteRequest = ref(false)
const handleChangeQuoteRequest = async (val: Array<IQuoteRequest>) => {
  loadingQuoteRequest.value = true
  try {
    if (val && Array.isArray(val) && val.length) {
      const api = $url.quote.quoteRequest.getDetail
      if (val.length && val[0] && val[0]._id) {
        const data = await $api(api, { uriParams: { ID: val[0]._id } })
        const resData: any = data?.data?.value
        if (resData.success) {
          Object.assign(dataCreateQuote.value, { ...resData.data })
          Object.assign(dataContact.value, { ...resData.data?.contactDetail })
          if (dataCreateQuote.value.contCategory) {
            dataCreateQuote.value.contName = listLabelCont[dataCreateQuote.value.contCategory] ?? ''
          }
        }
      }
    } else {
      dataCreateQuote.value = cloneDeep(defaultItems)
    }
    loadingQuoteRequest.value = false
  } catch (e: any) {
    loadingQuoteRequest.value = false
  }
}
const loadingSubmitCreateQuote = ref(false)
const handleSubmitCreateQuote = async (options: { [key: string]: any } = {}) => {
  loadingSubmitCreateQuote.value = true
  try {
    await handleSubmit(options)
    loadingSubmitCreateQuote.value = false
  } catch (e: any) {
    loadingSubmitCreateQuote.value = false
  }
}
const loadingSubmitCreateQuoteSendEmail = ref(false)
const handleSubmitCreateQuoteSendEmail = async (options: { [key: string]: any } = {}) => {
  loadingSubmitCreateQuoteSendEmail.value = true
  try {
    await handleSubmit(options)
    loadingSubmitCreateQuoteSendEmail.value = false
  } catch (e: any) {
    loadingSubmitCreateQuoteSendEmail.value = false
  }
}

const handleSubmit = async (options: { [key: string]: any } = {}) => {
  const result = addQuote.value && (await addQuote.value.handleCreateQuoteRequest(options))

  if (result) {
    dataCreateQuote.value = cloneDeep(defaultItems)
    visible.value = false
    page.value = 0
    emits('refreshTables')
  }
}

const ruleCreateQuote = {
  effectiveFromDate: 'required|min_date:1970-01-01',
  effectiveToDate: 'min_date:1970-01-01'
}
const cRules = computed(() => {
  if (addQuote.value && addQuote.value.step === 2 && addQuote.value.dataCreateQuote.effectiveFromDate) {
    const rules: { [key: string]: any } = { ...ruleCreateQuote }

    const date = addQuote.value.dataCreateQuote.effectiveFromDate ? new Date(addQuote.value.dataCreateQuote.effectiveFromDate) : ''
    if (date && addQuote.value.dataCreateQuote.effectiveToDate) {
      date.setDate(date.getDate() + 1)
      rules.effectiveToDate = rules.effectiveToDate + `|min_date:${date.toISOString().split('T')[0]}`
    }
    return rules
  }
  return {}
})

const drawer = ref()
</script>
